<div class="custom-dropdown slo-overlay">
  <div class="d-flex flex-column align-items-start spacing-16 w-100">
    <div class="d-flex align-items-center justify-content-between w-100">
      @if (type === 'delivered') {
        <div class="h4-bold primary-100 text-uppercase">Delivered</div>
      }
      @if (type === 'packed') {
        <div class="h4-bold primary-100 text-uppercase">Packed</div>
      }
      @if (type === 'in-transit') {
        <div class="h4-bold primary-100 text-uppercase">In transit</div>
      }
      <app-badges
        [withIcon]="false"
        Type="white"
        IconType="no_icon"
        [label]="shippingHeading.status.track"
        [ellipsis]="true"></app-badges>
    </div>
    <div class="border-line"></div>
    <div class="m-0 p-0 d-flex align-items-start flex-column spacing-8 w-100">
      @for (slo of shipping; track slo) {
        <div class="d-flex align-items-center justify-content-between w-100 primary-100 h4-reg">
          {{ slo.label }}
          <app-badges
            [withIcon]="false"
            Type="{{ slo.status.status_type }}"
            IconType="no_icon"
            [label]="slo.status.date"
            [ellipsis]="true"></app-badges>
        </div>
      }
    </div>
  </div>
</div>
